import React from 'react';
import HeroSection from './HeroSection';
import VideoShowcase from './VideoShowcase';
import LegalSolutionsShowcase from './LegalSolutionsShowcase';
import LandingFaq from './LandingFaq';

// Componente `HomePage` que renderiza esta parte de la interfaz.
const HomePage = ({ currentUser, onNavigate, t = {} }) => {
  return (
    <>
      <HeroSection
        t={t.hero || {}}
        currentUser={currentUser}
        onNavigate={onNavigate}
      />
      <VideoShowcase />
      <LegalSolutionsShowcase />
      <LandingFaq onNavigate={onNavigate} />
    </>
  );
};

export default HomePage;
